var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [_c("tasks-progress")], 1),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        {
          staticClass:
            "card card-primary card-outline card-outline-tabs sgp-card-default",
        },
        [
          _c("div", { staticClass: "card-header p-0 border-bottom-0" }, [
            _c(
              "ul",
              {
                staticClass: "nav nav-tabs",
                attrs: { id: "events", role: "tablist" },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      ref: "calendarTab",
                      staticClass: "nav-link",
                      attrs: {
                        id: "calendar-tab",
                        "data-toggle": "pill",
                        href: "#calendar",
                        role: "tab",
                        "aria-controls": "calendar",
                        "aria-selected": "true",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            Calendar\n                        "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c(
              "div",
              { staticClass: "tab-content", attrs: { id: "eventsContent" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade active show",
                    attrs: {
                      id: "timeline",
                      role: "tabpanel",
                      "aria-labelledby": "timeline-tab",
                    },
                  },
                  [_vm.tasksTimestamp ? _c("tasks-timeline") : _vm._e()],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    attrs: {
                      id: "calendar",
                      role: "tabpanel",
                      "aria-labelledby": "calendar-tab",
                    },
                  },
                  [
                    _vm.tasksTimestamp
                      ? _c("tasks-calendar", {
                          ref: "calendarWidget",
                          on: { click: _vm.onEventsCalendarClick },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c("div", { staticClass: "col-md-4 offset-md-8" }, [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-block sgp-btn-default",
                            attrs: { href: _vm.downloadCalendar },
                          },
                          [
                            _vm._v(
                              "\n                                    Download Calendar\n                                "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item" }, [
      _c(
        "a",
        {
          staticClass: "nav-link active",
          attrs: {
            id: "timeline-tab",
            "data-toggle": "pill",
            href: "#timeline",
            role: "tab",
            "aria-controls": "timeline",
            "aria-selected": "false",
          },
        },
        [
          _vm._v(
            "\n                            Timeline\n                        "
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }